// import React, { useState } from 'react'
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logoOfOurProject1 from '../Images/logoOfOurProject1.jpg'
import './Navigation.css'
import masteringAndBuilding from '../Images/masteringandbuilding.jpg'
import productmanagementai from '../Images/ProductManagementAI.jpg'
// import useScrollAnimation from './scroll';

const Navigation = () => {

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [courses, setCourses] = useState([
        { id: 1, title: 'MLOps Pro Specialization', path: '/mlops' },
        { id: 2, title: 'Mastering Data Analysis with Python', path: '/DataAnalysisWithPython' },
        { id: 3, title: 'Mastering GenAI Specialisation', path: '/masteringGenAI' },
        { id: 4, title: 'Data Science Masterclass', path: '/datasciencemasterclass' },
        { id: 4, title: 'Data Science Masterclass', path: '/datasciencemasterclass' }
        // Add more courses here or fetch from an API
    ]);

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        // Filter the courses based on the search query
        if (query) {
            const filtered = courses.filter((course) =>
                course.title.toLowerCase().includes(query)
            );
            setFilteredCourses(filtered);
        } else {
            setFilteredCourses([]);
        }
    };

    // useScrollAnimation();
    // Scroll animations on load and scroll
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll('.fade-in, .slide-in');
            elements.forEach(element => {
                const position = element.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;

                if (position < windowHeight) {
                    element.classList.add('show');
                }
            });
        };

        handleScroll(); // Trigger animation on load
        window.addEventListener('scroll', () => {
            const elements = document.querySelectorAll('.fade-in, .slide-in');
            elements.forEach(el => {
                const position = el.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;

                if (position < windowHeight - 100) {
                    el.classList.add('show');
                } else {
                    el.classList.remove('show'); // Ensures animation triggers again when scrolling back
                }
            });
        });

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className='container'>
            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                <div className="container-fluid">
                    <a href='/'><img src={logoOfOurProject1} alt='logo' /></a>
                    {/* <a className="navbar-brand fw-bold" href="/">KOTI AI</a> */}
                    {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button> */}
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-5">
                            <li className="nav-item me-3">
                                <a className="nav-link active fw-medium" aria-current="page" href="/">Home</a>
                            </li>
                            <li className="nav-item me-3">
                                <a className="nav-link fw-medium" href="#">Courses</a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="/datasciencemasterclass">Data Science</a></li>
                                    <li><a className="dropdown-item" href="/dataAnalysisWithPython">Data Analysis</a></li>
                                    <li><a className="dropdown-item" href="/masteringandbuildingproduct">Mastering AI Product- Langchain & LangGraph</a></li>
                                    <li><a className="dropdown-item" href="/productmanagementinai">Product Management In AI</a></li>
                                    <li><a className="dropdown-item" href="/masteringGenAI">Mastering Gen AI</a></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><a className="dropdown-item" href="/allcourses">More Courses</a></li>
                                </ul>
                            </li>
                            <li className="nav-item me-3">
                                <a className="nav-link fw-medium" href="#">Service</a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="#">Product Development</a></li>
                                    <li><a className="dropdown-item" href="/trainingandworkshop">Training & Workshops</a></li>
                                    <li><a className="dropdown-item" href="#">Customer Success</a></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link fw-medium" href="#">About</a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="/ourTeam">Our Team</a></li>
                                    {/* <li><a className="dropdown-item" href="#about-section">Mission & Vision</a></li> */}
                                    <li><a className="dropdown-item" href="#">Reviews</a></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><a className="dropdown-item" href="#contact-section">Contact Us</a></li>
                                </ul>
                            </li>
                        </ul>

                        {/* Search Bar */}


                        <div className="search-bar-container" style={{ position: 'relative', width: '50%' }}>
                            <form className="d-flex" role="search" onSubmit={(e) => e.preventDefault()}>
                                <input
                                    className="form-control me-2"
                                    type="search"
                                    value={searchQuery}
                                    onChange={handleSearch}
                                    placeholder="Search for courses..."
                                    aria-label="Search"
                                    autoComplete="on"
                                />
                                <button className="btn btn-outline-success" type="submit">Search</button>

                                {/* Dropdown search results */}
                                {searchQuery && filteredCourses.length > 0 && (
                                    <div className="dropdown-search-results">
                                        <ul>
                                            {filteredCourses.map((course) => (
                                                <li key={course.id}>
                                                    <Link to={course.path} onClick={() => setSearchQuery('')}>
                                                        {course.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </form>


                        </div>

                        {/* Search Bar End  */}

                    </div>
                </div>
            </nav>
            <div className='container justify-content-center p-5'>
                <h1 className=''>
                    All Programes
                </h1>
            </div>

            {/* All Courses  */}

            <div className='card-group p-5 slide-in'>
                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src={masteringAndBuilding} loading="eager" />
                    <div className="card-body ">
                        <h3 className="card-title">Mastering AI Product- Langchain & LangGraph</h3>
                        <p className="card-text">Learn live from experts.</p>
                        <p className="card-text fw-bolder">Coming Soon</p>
                        <a href="/masteringandbuildingproduct" className="btn btn-primary">View Details</a>
                    </div>
                </div>
                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src={productmanagementai} loading="eager" />
                    <div className="card-body ">
                        <h3 className="card-title">Product Management In AI</h3>
                        <p className="card-text">Learn live from experts.</p>
                        <p className="card-text fw-bolder">Coming Soon</p>
                        <a href="/productmanagementinai" className="btn btn-primary">View Details</a>
                    </div>
                </div>

                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src="https://static.wixstatic.com/media/f18369_f8074f5749fc45259e9eee80d3f9a824~mv2.jpg/v1/fit/w_800,h_600,al_c,q_90/file.webp" loading="eager" />
                    <div className="card-body">
                        <h3 className="card-title">Mastering GenAI Specialisation</h3>
                        <p className="card-text">Advanced AI skills.</p>
                        <a href="/masteringGenAI" className="btn btn-primary">View Details</a>
                    </div>
                </div>
            </div>
            <div className='card-group p-5 slide-in'>
                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src="https://static.wixstatic.com/media/f18369_be8fdc2991e44a67889436374b58b225~mv2.jpg/v1/fit/w_800,h_600,al_c,q_90/file.webp" loading="eager" />
                    <div className="card-body ">
                        <h3 className="card-title">MLOps Pro Specialization</h3>
                        <p className="card-text">Learn live from experts.</p>
                        <p className="card-text fw-bolder">Coming Soon</p>
                        <a href="/mlops" className="btn btn-primary">View Details</a>
                    </div>
                </div>

                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src="https://static.wixstatic.com/media/f18369_956efaa403484768a72a76a38933c387~mv2.png/v1/fit/w_800,h_600,al_c,q_90/file.webp" loading="eager" />
                    <div className="card-body">
                        <h3 className="card-title">Mastering Data Analysis with Python</h3>
                        <p className="card-text">Learn live from experts.</p>
                        <p className="card-text fw-bolder">Coming Soon</p>
                        <a href="/DataAnalysisWithPython" className="btn btn-primary">View Details</a>
                    </div>
                </div>


                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src="https://static.wixstatic.com/media/f18369_b06a2a054e88427fa9f9ff35824580c9~mv2.jpg/v1/fit/w_800,h_600,al_c,q_90/file.webp" loading="eager" />
                    <div className="card-body">
                        <h3 className="card-title">Data Science Masterclass</h3>
                        <p className="card-text">Unlock data analysis and interpretation.</p>
                        <p className="card-text fw-bolder">Coming Soon</p>
                        <a href="/datasciencemasterclass" className="btn btn-primary">View Details</a>
                    </div>
                </div>

            </div>
            <div className='card-group p-5 slide-in'>
                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src="https://static.wixstatic.com/media/f18369_5a9f179f88e9451a870add6d2d53f1d9~mv2.jpg/v1/fit/w_800,h_600,al_c,q_90/file.webp" loading="eager" />
                    <div className="card-body ">
                        <h3 className="card-title">Advanced LLM Ops Specialization</h3>
                        <p className="card-text">Learn live from experts.</p>
                        <p className="card-text fw-bolder">Coming Soon</p>
                        <a href="/advancedllm" className="btn btn-primary">View Details</a>
                    </div>
                </div>
            </div>
            <footer>
                <div className='footer p-4 bg-dark'>
                    <div className='d-flex justify-content-between'>
                        <div className='footer-social text-white'>
                            <h4>Follow us!</h4>
                            <br />
                            <div className='footer-social-links-1'>
                                <a href="https://www.facebook.com/imtusharchaudhary" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Facebook-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                                <a href="https://www.Twitter.com/Tusharcofficial" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Twitter-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                                <a href="https://www.instagram.com/iamtusharchaudhry" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Instagram-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                            </div>
                        </div>
                        <div className='AboutCompany text-white'>
                            <h4>Company</h4>
                            <p className='text-white-50'>Carrers</p>
                            <p className='text-white-50'>Newsroom</p>
                            <p className='text-white-50'>Alumni Speak</p>
                            <p className='text-white-50'>Grievance redreesal</p>
                        </div>
                        <div className='WorkWithUs text-white'>
                            <h4>Work With Us</h4>
                            <p className='text-white-50'>Become an instructor</p>
                            <p className='text-white-50'>Blog as guest</p>
                        </div>
                        <div className='ForBusinesses text-white' id='contact-section'>
                            <h4>Contact Us</h4>
                            <p className='text-white-50'></p>
                            <p className='text-white-50'><i class="bi bi-phone"></i>&nbsp; Request a callback</p>
                            <p className='text-white-50'><i class="bi bi-telephone-plus-fill"></i>&nbsp; +91 8448-313599</p>
                            <p className='text-white-50'><i class="bi-envelope-fill"></i>&nbsp; info@kotiai.com</p>
                        </div>
                    </div>
                </div>
                <div className='footer-bottom'>
                    <p>© 2024 kotiai.com | Terms of Service | Privacy Policy</p>
                </div>
            </footer>
        </div>
    )
}

export default Navigation